'use client';

import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { PropsWithChildren } from 'react';

export function Providers({ children }: PropsWithChildren) {
    return (
        <NuqsAdapter
            defaultOptions={{
                clearOnDefault: true,
                history: 'push',
                shallow: false,
            }}
        >
            {children}
        </NuqsAdapter>
    );
}
